import { render, staticRenderFns } from "./institutions_table.vue?vue&type=template&id=ef30185a&"
import script from "./institutions_table.vue?vue&type=script&lang=js&"
export * from "./institutions_table.vue?vue&type=script&lang=js&"
import style0 from "./institutions_table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports